// extracted by mini-css-extract-plugin
export default {"livePostComment":"LivePost_livePostComment__F5Hc1"};